import { IMAGE_SCENES } from '../configs/media/imageScenes';
// Lookup by ID
export function getImageSceneById(id) {
    return IMAGE_SCENES.scenes.find((scene) => scene.id === id);
}
// Filtering
export function getImageScenesByGame(gameId) {
    return IMAGE_SCENES.scenes.filter((scene) => scene.games?.includes(gameId) || scene.games?.includes('*'));
}
// Path and metadata
export function getImageScenePath(id) {
    const scene = getImageSceneById(id);
    if (!scene)
        throw new Error(`Invalid image scene ID: ${id}`);
    return scene.path;
}
//# sourceMappingURL=getImageScenes.js.map